
import { Options, Vue } from "vue-class-component";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import Loading from "@/app/ui/components/loading/index.vue";
import ErrorMessage from "@/app/ui/components/error-message/index.vue";

@Options({
  components: {
    Loading,
    ErrorMessage,
  },
})
export default class PerformaIframe extends Vue {
  iframeLoaded = false;

  mounted() {
    this.loadEmbed();
  }

  async loadEmbed() {
    try {
      await DashboardController.getPerformanceEmbed();
    } catch {
      // error handled by controller state
    }
  }

  onRetry() {
    this.loadEmbed();
  }

  onIframeLoad() {
    this.iframeLoaded = true;
  }

  get isLoading() {
    return DashboardController.isLoadingPerformanceEmbed;
  }

  get isError() {
    return DashboardController.isErrorPerformanceEmbed;
  }

  get errorCause() {
    return DashboardController.errorCausePerformanceEmbed;
  }

  get embedUrl() {
    return DashboardController.performanceEmbedData.embedUrl;
  }
}
